"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import React from "react";
import _ from "underscore";
import Utils from "../../util/drawing_utils";
import AnnotationComponents from "./components";
import handleHover from "./highlight_on_hover";
import showDragPoints from "./show_drag_points";
import WaitingSpinner from "../../components/waiting_spinner";
const createComponentInfo = ({
  handlers,
  hover,
  selected,
  width,
  height,
  annotating,
  annotationStampUrl,
  cropping,
  page
}) => (component) => {
  const hovered = component.guid === hover.viewID;
  const isSelected = selected && component.guid === selected.guid;
  const hoveredDragPointIndex = hovered ? hover.dragPointIndex : null;
  return {
    guid: component.guid,
    AnnotationComponent: AnnotationComponents[component.typeID],
    props: __spreadProps(__spreadValues({}, component), {
      handlers: handlers.component,
      hovered,
      selected: isSelected,
      canvasWidth: width,
      canvasHeight: height,
      hoveredDragPointIndex,
      annotating,
      cropping,
      page,
      annotationStampUrl
    })
  };
};
const createComponent = ({ AnnotationComponent, props, guid }) => {
  const Component = handleHover(AnnotationComponent);
  return /* @__PURE__ */ createElement(Component, __spreadProps(__spreadValues({}, props), { key: guid }));
};
const wrap = (wrapper) => ({ AnnotationComponent, props, guid }) => {
  const WrappedComponent = wrapper(AnnotationComponent);
  if (!WrappedComponent) {
    return void 0;
  }
  return /* @__PURE__ */ createElement(WrappedComponent, __spreadProps(__spreadValues({}, props), { key: guid }));
};
function deleteSelected(props, e) {
  if (_.contains([8, 46], e.keyCode) && props.annotating && props.selected && props.handlers && !props.editedTextAnnotation) {
    e.preventDefault();
    props.handlers.deleteAnnotation(props.selected.guid);
  }
}
function annotationComponents(props) {
  const comps = props.annotationComponents || [];
  return comps.sort((a, b) => {
    if (a.type === "Crop") {
      return 1;
    } else if (b.type === "Crop") {
      return -1;
    }
    return a.id - b.id;
  });
}
function dragPoints(props, components) {
  if (props.annotating) {
    return components.map(wrap(showDragPoints));
  }
  return [];
}
class AnnotationSurface extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onKeyDown");
    __publicField(this, "onMouse", (event) => {
      event.preventDefault();
      const coords = Utils.relMouseCoords(
        event,
        this.refs.annotation_canvas
      );
      const canvasRect = document.getElementsByClassName("document-browser__zoomable-container")[0].getBoundingClientRect();
      const handlers = this.props.handlers.canvas;
      switch (event.type) {
        case "mousedown":
        case "touchstart":
          handlers.onMouseDown(coords);
          break;
        case "mousemove":
        case "touchmove":
          handlers.onMouseMove(coords, canvasRect);
          break;
        case "mouseup":
        case "touchend":
          handlers.onMouseUp(coords);
          break;
        case "touchcancel":
          break;
        default:
          return;
      }
    });
  }
  componentDidMount() {
    this.props.handlers.canvas.canvasSizeUpdated(
      this.props.width,
      this.props.height
    );
    this.props.handlers.loadAnnotations(this.props.page);
    this.onKeyDown = (e) => deleteSelected(this.props, e);
    window.addEventListener("keydown", this.onKeyDown);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
      this.props.handlers.canvas.canvasSizeUpdated(
        this.props.width,
        this.props.height
      );
    }
    if (this.props.page.id !== prevProps.page.id) {
      this.props.handlers.updateAnnotations(this.props.page);
    }
  }
  render() {
    const components = annotationComponents(this.props).map(
      createComponentInfo(this.props)
    );
    const annotationElements = components.map(createComponent);
    const mouseHandler = this.props.annotating ? this.onMouse : void 0;
    const dragPointElements = dragPoints(this.props, components);
    return /* @__PURE__ */ jsx(
      WaitingSpinner,
      {
        "data-component": "AnnotationSurface",
        when: this.props.loading,
        children: /* @__PURE__ */ jsx(
          "div",
          {
            ref: "annotation_canvas",
            onMouseDown: mouseHandler,
            onMouseMove: mouseHandler,
            onMouseUp: mouseHandler,
            onTouchStart: mouseHandler,
            onTouchMove: mouseHandler,
            onTouchEnd: mouseHandler,
            onTouchCancel: mouseHandler,
            style: { padding: 0, margin: 0, border: 0 },
            className: this.props.loading ? "loading" : "loaded",
            children: /* @__PURE__ */ jsxs("svg", { width: this.props.width, height: this.props.height, children: [
              annotationElements,
              dragPointElements
            ] })
          }
        )
      }
    );
  }
}
__publicField(AnnotationSurface, "defaultProps", {
  annotationComponents: [],
  handlers: {
    loadAnnotations: () => {
    },
    deleteAnnotation: () => {
    },
    canvas: {
      onMouseDown: () => {
      },
      onMouseMove: () => {
      },
      onMouseUp: () => {
      },
      canvasSizeUpdated: () => {
      }
    }
  }
});
export default AnnotationSurface;
